import { ref, computed } from 'vue';
import { defineStore } from 'pinia';
import { useSettingsStore } from '../../';



const useDocumentStore = defineStore('document', () => {
  const data = ref<string>('');
  const { settings } = useSettingsStore();

  function setDocumentTitle(targetTitle?: string) {
    document.title = settings.system.getDocumentTitle(targetTitle)
    data.value = document.title;
  }

  return {
    data: computed(() => data.value),
    setDocumentTitle,
  };
});

export default useDocumentStore;
